import { createApi } from '@reduxjs/toolkit/query/react'
import BaseService from '@/lib/BaseService'
import type { BaseQueryFn } from '@reduxjs/toolkit/query'
import type { AxiosRequestConfig, AxiosError } from 'axios'
import { logger } from '@/utils/logger'

const axiosBaseQuery =
    (): BaseQueryFn<
        {
            url: string
            method: AxiosRequestConfig['method']
            data?: AxiosRequestConfig['data']
            params?: AxiosRequestConfig['params']
        },
        unknown,
        unknown
    > =>
    async (request) => {
        try {
            logger.debug('RTK Query request:', {
                url: request.url,
                method: request.method,
                hasParams: !!request.params,
                hasData: !!request.data
            })
            const response = await BaseService(request)
            logger.debug('RTK Query response success:', { url: request.url })
            return { data: response.data }
        } catch (axiosError) {
            const err = axiosError as AxiosError
            logger.error('RTK Query error:', {
                url: request.url,
                method: request.method,
                status: err.response?.status,
                statusText: err.response?.statusText,
                message: err.message,
                responseData: err.response?.data
            })
            return {
                error: {
                    status: err.response?.status,
                    data: err.response?.data || err.message,
                },
            }
        }
    }

const RtkQueryService = createApi({
    reducerPath: 'rtkApi',
    baseQuery: axiosBaseQuery(),
    tagTypes: ['Obj', 'Dal'],
    endpoints: () => ({}),
})

export default RtkQueryService
